module.exports = __webpack_public_path__ + "static/media/load_init.f03f6ceb.gif";